import { useEffect, useRef, useState } from 'react';
import styled from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "AutoHeightSlide__Container"
})(["overflow:hidden;transition-property:block-size,opacity;transition-timing-function:ease-in-out;"]);
/**
 * Smoothly slides its block-size between 0 and the natural height of its
 * children. A ResizeObserver tracks the inner content's height so the
 * container holds a real pixel value to animate against — even when children
 * unmount in the same render that triggers the collapse.
 */
export function AutoHeightSlide({
  expanded,
  children,
  durationMs = 200,
  exitDurationMs
}) {
  const activeDuration = expanded ? durationMs : exitDurationMs !== null && exitDurationMs !== void 0 ? exitDurationMs : durationMs;
  const innerRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  useEffect(() => {
    const el = innerRef.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      setContentHeight(entry.contentRect.height);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return /*#__PURE__*/_jsx(Container, {
    "aria-hidden": !expanded,
    style: {
      blockSize: expanded ? contentHeight : 0,
      opacity: expanded ? 1 : 0,
      // Opacity runs ~30% longer than the height slide so the fade settles
      // just after the slide ends — a subtle softening on enter and exit.
      transitionDuration: `${activeDuration}ms, ${Math.round(activeDuration * 1.3)}ms`
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: innerRef,
      children: children
    })
  });
}